import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useNavigate } from "react-router-dom";
import "../../../assets/DataView/DataViewDemo.css";
import "../../../assets/DataView/index.css";
import "../../../assets/css/AccordionDemo.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import jsPDF from "jspdf";
import logoBig from "../../../assets/logo1.png";
import { FilterMatchMode } from 'primereact/api';
import { addBulkCities, getStateCities } from "../../../services/userMasterUser";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { formatDate } from "../../../constants/FormateDate";
import { bankerListUpload } from "../../../services/bankListUpload";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";

export default function StateCitiesList() {

  const navigate = useNavigate();

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);

  const ds = useRef(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(100);
  const [loadingMore, setLoadingMore] = useState(false);

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    city: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    state: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    
  });

  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [searchByStatus, setSearchByStatus] = useState('city');

  const searchByStatusData = [
    { label: "City", value: "city" },
    { label: "State", value: "state" },
  ];

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 100,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    cityIn: [],
    stateIn : []
  };

  const fetchData = (data, append = false) => {
    setLoadingMore(true);

    getStateCities(data)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs

          if (append) {
            setProducts((prev) => [...(prev || []), ...newData]);
          } else {
            setProducts(newData);
          }

          setTotalRecords(response.data.totalRecords || newData.length);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  useEffect(() => {
    fetchData({
      ...typeData,
      limit: rows,
      offset: 0
    });
  }, []);

  const loadMore = () => {
    const newOffset = first + rows;

    fetchData(
      {
        ...typeData,
        limit: rows,
        offset: newOffset
      },
      true // append mode
    );

    setFirst(newOffset);
  };

  const onFilter = (event) => {
    setFilters(event.filters);

    let searchBy = "";
    let searchText = "";

    // Detect which column filter is applied
    Object.keys(event.filters).forEach((key) => {
      if (key !== "global" && event.filters[key]?.value) {
        searchBy = key;
        searchText = event.filters[key].value;
      }
    });

    fetchData({
      searchBy,
      searchText,
      limit: 100,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    });
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;

    setGlobalFilterValue(value);
    setFirst(0);
    setProducts([]);

    fetchData({
      searchBy: searchByStatus,
      searchText: value,
      limit: 100,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    });
  };

  const itemTemplate = (data) => {
    return (
      <div>
      </div>
    )
  }

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/masters")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> State Cities List
                </h5>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">
                    <div className="col-md mb-2">
                      <InputText
                        type="text"
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={searchByStatusData}
                        value={searchByStatus}
                        onChange={(e) => {
                          setSearchByStatus(e.value);
                        }}
                      />
                    </div>

                  </div>

                  <div className="row">
                    <div className="col-md">
                      <Link
                        to="/user-master/stateCitiesBulk/create"
                        className="move-btn move-btn-blue center-text"
                      >
                        Create
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      // lazy
                      dataKey="id"
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={rows}
                      rowsPerPageOptions={[rows, rows + 50, rows + 100]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      filters={filters}
                      onFilter={onFilter}
                      // filterDisplay="row"
                      globalFilterFields={['id', 'createdDate', 'name', "mobile", "city", "state"]}
                      stripedRows
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>
                      <Column
                        field="state"
                        header="State"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.state}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="city"
                        header="City"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.city}
                          </span>
                        )}
                      ></Column>
                       
                      <Column
                        field="status"
                        header="Status"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData.status ? "ACTIVE" : "INACTIVE")}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="Edit"
                        header="Edit"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/user-master/stateCities/edit"}
                            state={rowData}
                            className="move-btn move-btn-yellow center-text"
                          >
                            Edit <i className="bi bi-pencil-square"></i>
                          </Link>
                        )}
                      ></Column>
                    </DataTable>
                  </div>
                  <DataScroller
                    ref={ds} 
                    value={products} 
                    itemTemplate={itemTemplate} 
                    rows={5} 
                    loader 
                    // footer={footer} 
                    // header="Click Load Button at Footer to Load More" 
                  />
                  <div
                    className="flex justify-content-center fixed "
                    style={{ bottom: 30, left: 20 }}
                  >
                    <Button
                      type="text"
                      icon="pi pi-plus"
                      // label="More"
                      onClick={loadMore} // Update this to trigger `getData`
                    />
                  </div>
                  {/*products && products.length < totalRecords && (
                    <div style={{ textAlign: "center", margin: "20px" }}>
                      <button
                        onClick={loadMore}
                        disabled={loadingMore}
                        style={{
                          padding: "10px 20px",
                          backgroundColor: "#1e439b",
                          color: "#fff",
                          border: "none",
                          cursor: "pointer",
                          borderRadius: "5px"
                        }}
                      >
                        {loadingMore ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
